<template>
  <v-app>
    <v-layout>
      <v-main>
        <router-view
          @handleChangeHeaderFooter="handleChangeHeaderFooter"
          @handleChangeFooterType="handleChangeFooterType"
        ></router-view>
      </v-main>
    </v-layout>
    <AppNotification />
  </v-app>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import AppNotification from "@/components/AppNotification.vue";
import { useLocaleStore } from "./store/locale";

const route = useRoute();
const store = useStore();
const localeStore = useLocaleStore();

onMounted(() => {
  document.title = "Builder - the Educator's Buddy";

  // Initialize cart from localStorage on app startup
  localeStore.initializeLocale();
  store.dispatch("initializeCart");
});

// Data
const showHeader = ref(true);
const showFooter = ref(true);
// eslint-disable-next-line
const headerType = computed(() => route.meta.footer);
const footerType = computed(() => route.meta.footer ?? "standart-footer");

// eslint-disable-next-line
const handleChangeHeaderFooter = (showHeaderVal, showFooterVal) => {
  showHeader.value = showHeaderVal;
  showFooter.value = showFooterVal;
};

// eslint-disable-next-line
const handleChangeFooterType = (footerTypeVal) => {
  footerType.value = footerTypeVal;
};

// When page closed or refreshed remove all local storage data
window.addEventListener("beforeunload", () => {
  localStorage.removeItem("lessonPreviewData");
});
</script>
